<template>
<div class="row justify-content-center align-content-center">
    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/market.jpg" alt="MarketPlace ejemplo" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Market place</h5>
        <p class="card-text texto_base2">Ejemplo de un portal MarketPlace para comprar productos en línea. Hecho con Quasar Framework</p>
        <a href="https://estebanlab2021.github.io/pagemarketplace/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/list.jpg" alt="ToDo List" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Aplicación Web ToDo List</h5>
        <p class="card-text texto_base2">Ejemplo de una aplicación web tipo Todo List. Realizado con Vue Framework</p>
        <a href="https://estebanlab2021.github.io/ToDoList/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/sumaresta.jpg" alt="Aprende a Sumar" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Aplicación Web Aprende a Sumar</h5>
        <p class="card-text texto_base2">Ejemplo de una Apicación web para un juego infantil de aprendizaje. Hecho con Vue Framework</p>
        <a href="https://estebanlab2021.github.io/aprende-sumar/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/leerescribir.jpg" alt="Aprende a Leer y Escribir" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Aplicación Web Aprende a Leer y Escribir</h5>
        <p class="card-text texto_base2">Ejemplo de una Apicación web para un juego infantil de aprendizaje. Hecho con bootstrap framework y javascript</p>
        <a href="https://estebanlab2021.github.io/aprende_escribir/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/calculadora.jpg" alt="Calculadora" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Aplicación Web Calculadora</h5>
        <p class="card-text texto_base2">Ejemplo de realización de una calculadora tradicional en línea. Hecho con bootstrap framework y javascript</p>
        <a href="https://estebanlab2021.github.io/calculadora/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

    <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img class="card-img-top" src="../assets/personal.jpg" alt="Web Personales" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <h5 class="card-title">Paginas Web Personales</h5>
        <p class="card-text texto_base2">Ejemplo de una página web personal hecho con html, css y bootstrap framework </p>
        <a href="https://estebanlab2021.github.io/pageinmobiliaria/" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
    </div>

</div>
  
</template>

<script>
export default {
    name:'Desarrollador',

}
</script>

<style>

</style>